/* 商品页信息区顺序：图片 → 标题 → 价格 → 满减 → 分期 → 选项。
   定制器（TeeinBlue）把价格渲染在自己的表单里，和满减块不在同一层级，CSS 的 order 跨不过去，
   只能在 DOM 里把这个节点搬到满减块前面。插件换尺码时是原地更新节点（实测价格会跟着变），
   所以搬一次就够；为防止插件重绘把它塞回表单，留一个短期 observer 兜底。 */
(function () {
  var info = document.querySelector('.product__info-container');
  if (!info) return;

  function place() {
    var price = info.querySelector('.tee-product-price');
    var anchor = info.querySelector(':scope > .cuszoo-volume-discount');
    if (!price || !anchor) return false;
    if (price.nextElementSibling === anchor) return true;
    info.insertBefore(price, anchor);
    return true;
  }

  if (place()) return;

  var observer = new MutationObserver(function () {
    if (place()) observer.disconnect();
  });
  observer.observe(info, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 20000);
})();
